import { ChemistryPlayerPositions, TeamChemistry } from "../types/IOption";
import Alert from "../assets/icons/Alert.png";
import { Theme } from "../styles/Theme";
import * as d3 from "d3";
import { appendText, appendCircle, getColorByValue, appendRect } from "./pitchWidgetUtils";
import noImagePlayer from "../assets/icons/noImagePlayer.svg";
import noImageClub from "../assets/icons/noImageClub.svg";
import Goalkeeper from "../assets/icons/Goalkeeper.png";

export const drawModuleChemistrys = (
  svg: d3.Selection<SVGGElement, any, null, undefined>,
  xScale: d3.ScaleLinear<number, number>,
  yScale: d3.ScaleLinear<number, number>,
  positionResults: ChemistryPlayerPositions[],
  teamChemistry: TeamChemistry[],
  fullView: boolean,
  modulefitPlayer: number,
  theme: Theme
) => {
  const linesGroup = svg.append("g").attr("class", "lines-group");
  positionResults?.map((player) => {
    const centerX = xScale(player.xCoordinate);
    const centerY = yScale(player.yCoordinate);
    if (player?.positionCode === "gk") {
      svg.append('image')
      .attr("xlink:href", Goalkeeper)
      .attr("width", 20)
      .attr("height", 20)
      .attr("x", centerX)
      .attr("y", centerY - 20 / 2);
    } else if (player?.playerId > 0) {
      appendCircle(
        svg,
        centerX,
        centerY,
        player?.playerId === modulefitPlayer ? 10 : 7,
        player?.playerId === modulefitPlayer ? "#3EA2FF" : teamChemistry?.find(conection => conection?.player1 === player?.playerId || conection?.player2 === player?.playerId) ? "white" : "#00D1A8",
        player?.playerId > 0 ? "none" : "5,5",
        teamChemistry?.find(conection => conection?.player1 === player?.playerId || conection?.player2 === player?.playerId) ? 2 : 0,
        player?.playerId === modulefitPlayer ? "white" : theme.playerCardBorderColor
      );
    }
  });
  teamChemistry?.forEach((connection) => {
    const startPlayer = positionResults?.find((player) => player.playerId === connection.player1);
    const endPlayer = positionResults?.find((player) => player.playerId === connection.player2);
    if (startPlayer && endPlayer) {
      linesGroup
        .append("line")
        .attr("x1", xScale(startPlayer.xCoordinate))
        .attr("y1", yScale(startPlayer.yCoordinate))
        .attr("x2", xScale(endPlayer.xCoordinate))
        .attr("y2", yScale(endPlayer.yCoordinate))
        .style(
          "stroke",
          connection.score > 0 ? getColorByValue(connection.score) : startPlayer.playerId > 0 ? theme.NumberColor : theme.playerDataBorder
        )
        .style("stroke-width", 3.8)
        .style("stroke-dasharray", connection.isPredictive ? "5,5" : "none");
    } else {
      console.warn("Start player or end player not found for connection:", connection);
    }
  });
};

export const drawLargeModuleChemistrys = (
  svg: d3.Selection<SVGGElement, any, null, undefined>,
  xScale: d3.ScaleLinear<number, number>,
  yScale: d3.ScaleLinear<number, number>,
  positionResults: ChemistryPlayerPositions[],
  teamChemistry: TeamChemistry[],
  theme: Theme,
  newPlayerID?: number,
  newPlayerClubURL?: string,
  oldPlayer?: number,
  isShowClubImg?: boolean
) => {
  const linesGroup = svg.append("g").attr("class", "lines-group");
  const circleSize = window.innerWidth < 800 || window.innerHeight < 800 ? 18 : 25;
  const imageSize = window.innerWidth < 800 || window.innerHeight < 800 ? 33 : 50;
  positionResults?.map((player) => {
    svg.append("clipPath").attr("id", "playerImageClipPath");
    if (player.playerId > 0) {
      const centerX = xScale(player.xCoordinate);
      const centerY = yScale(player.yCoordinate);
      svg.select("#playerImageClipPath").append("circle").attr("cx", centerX).attr("cy", centerY).attr("r", circleSize);
      appendCircle(svg, centerX, centerY, circleSize, "#D9D9D9", "none", 1, theme.playerCardBorderColor);
      svg
        .append("image")
        .attr("xlink:href", player.playerImageURL ? player.playerImageURL : noImagePlayer)
        .attr("width", imageSize)
        .attr("height", imageSize)
        .attr("cursor", "pointer")
        .attr("x", centerX - imageSize / 2)
        .attr("y", centerY - imageSize / 2);
      {
        player.playerId === newPlayerID && isShowClubImg &&
          svg
            .append("svg:image")
            .attr("xlink:href", newPlayerClubURL ? newPlayerClubURL : noImageClub)
            .attr("x", centerX + 12)
            .attr("y", centerY - 70 / 2)
            .attr("width", 25)
            .attr("height", 25);
      }
    }
  });
  if (positionResults?.length > 1) {
    positionResults?.map((player) => {
      const centerX = xScale(player.xCoordinate);
      const centerY = yScale(player.yCoordinate);
      const textPosition = window.innerWidth < 800 || window.innerHeight < 800 ? centerY + 54 / 2 + 8 : centerY + 30 + 13;
      const nametext = svg
        .append("text")
        .attr("text-anchor", "middle")
        .attr("dominant-baseline", "bottom")
        .attr("x", centerX)
        .attr("y", textPosition)
        .attr("fill", "none")
        .text(player?.playerId === 365443 ? 'DE LIGT' : player?.shortName?.split(/\.|\s/)?.filter(Boolean)[1]?.toUpperCase() || player?.shortName?.toUpperCase())
        .style("font", "10px Aeonik");
      const textWidth = nametext.node()!.getBBox();
      {
        player.playerId > 0 &&
          appendRect(
            svg,
            textWidth.width + 2 * 6,
            textWidth.height + 2 * 6,
            centerX - (textWidth.width + 2 * 6) / 2,
            textPosition,
            player.playerId === oldPlayer
              ? "#00A1E4"
              : player.playerId === newPlayerID
              ? "#00D1A8"
              : theme.secondaryButtonBackground,
            0,
            1,
            theme.secondaryButtonBorderColor,
            1,
            "none",
            `translate(-${0}, -${textWidth.height * 0.9 + 6})`
          );
      }
      appendText(
        svg,
        centerX,
        textPosition,
        player?.playerId === 365443 ? 'DE LIGT' : player?.shortName?.split(/\.|\s/)?.filter(Boolean)[1]?.toUpperCase() || player?.shortName?.toUpperCase(),
        player.playerId === oldPlayer ? "white" : player.playerId === newPlayerID ? "black" : theme.playerColor,
        "Aeonik",
        600,
        10,
        1,
        "middle"
      );
    });
  }
  teamChemistry?.forEach((connection) => {
    const startPlayer = positionResults.find((player) => player.playerId === connection.player1);
    const endPlayer = positionResults.find((player) => player.playerId === connection.player2);
    if (startPlayer && endPlayer) {
      let startX = xScale(startPlayer.xCoordinate);
      let startY = yScale(startPlayer.yCoordinate);
      let endX = xScale(endPlayer.xCoordinate);
      let endY = yScale(endPlayer.yCoordinate);
      let distance = Math.sqrt(Math.pow(endX - startX, 2) + Math.pow(endY - startY, 2));
      linesGroup
        .append("line")
        .attr("x1", xScale(startPlayer.xCoordinate))
        .attr("y1", yScale(startPlayer.yCoordinate))
        .attr("x2", xScale(endPlayer.xCoordinate))
        .attr("y2", yScale(endPlayer.yCoordinate))
        .style(
          "stroke",
          connection.score > 0 ? getColorByValue(connection.score) : startPlayer.playerId > 0 ? theme.NumberColor : theme.playerDataBorder
        )
        .style("stroke-width", 2.8)
        .style("stroke-dasharray", connection.isPredictive ? "5,5" : "none");
      const centerX = (xScale(startPlayer.xCoordinate) + xScale(endPlayer.xCoordinate)) / 2;
      const centerY = (yScale(startPlayer.yCoordinate) + yScale(endPlayer.yCoordinate)) / 2;
      const offsetX = (xScale(startPlayer.xCoordinate) + centerX) / 2;
      const offsetY = (yScale(startPlayer.yCoordinate) + centerY) / 2;
      const X = distance > 170 ? (offsetX + xScale(endPlayer.xCoordinate)) / 2 : centerX;
      const Y = distance > 170 ? (offsetY + yScale(endPlayer.yCoordinate)) / 2 : centerY;
      {
        startPlayer.playerId > 0 &&
          connection.score === 0 &&
          linesGroup.append("circle").attr("cx", X).attr("cy", Y).attr("r", 14).style("fill", theme.NumberColor);
      }
      {
        startPlayer.playerId > 0 &&
          connection.score === 0 &&
          linesGroup
            .append("svg:image")
            .attr("xlink:href", () => Alert)
            .attr("x", X - 20 / 2)
            .attr("y", Y - 20 / 2)
            .attr("width", 20)
            .attr("height", 20)
            .style("pointer-events", "none");
      }
      {
        connection.score > 0 && appendCircle(linesGroup, X, Y, 14, getColorByValue(connection.score), "none", 0, "none");
      }
      {
        connection.score > 0 &&
          appendText(
            linesGroup,
            X,
            Y + 4,
            connection.score,
            connection.score <= 49 ? "#FFFFFF" : "#111111",
            "DM Mono",
            500,
            12,
            1,
            "middle",
            "none",
            "pointer"
          );
      }
    } else {
      console.warn("Start player or end player not found for connection:", connection);
    }
  });
};
